// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"JV-z","inlineTitle":"KV-z","sponsoredAdsWrapper":"LV-z","marketplaceRecosWrapper":"MV-z"};